module.exports = __webpack_public_path__ + "img/sigfox.69224dec.png";